import script from "./NotificationChannel.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationChannel.vue?vue&type=script&setup=true&lang=js"

import "./NotificationChannel.vue?vue&type=style&index=0&id=dab5263e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dab5263e"]])

export default __exports__